import styled from 'styled-components';
import { UIButton } from '../UI';

export const DontKnowMyCEPButton = styled(UIButton)`
  margin-top: -10px;
  text-decoration: underline;
`;
